import { createAsyncThunk } from "@reduxjs/toolkit";
import CompanyServices from "../../Services/companyServices";
import { ResponseMessageHandler } from "../../globals/components/notification";
import { getLicencingData } from "../Licensing/Licences.Action";
import DatamanagerServices from "../../Services/DatamanagerServices";
export const getCompanydetails = createAsyncThunk(
  "Company/getCompanydetails",
  async (data, thunkAPI) => {
    try {
      let res = await CompanyServices.getCompanyAPI({
        ...data,
        limit: data.pageSize,
        page: data.current,
      });
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const createCompany = createAsyncThunk(
  "Company/createCompany",
  async ({ data, companyPagination }, thunkAPI) => {
    try {
      const res = await CompanyServices.createCompanyAPI(data);
      thunkAPI.dispatch(getCompanydetails(companyPagination));
      ResponseMessageHandler(res);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const updateCompany = createAsyncThunk(
  "Company/updateCompany",
  async ({ data, companyPagination }, thunkAPI) => {
    try {
      const res = await CompanyServices.createCompanyAPI(data);
      thunkAPI.dispatch(getCompanydetails(companyPagination));
      ResponseMessageHandler(res);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const deleteCompany = createAsyncThunk(
  "Company/deleteCompany",
  async ({ data, companyPagination }, thunkAPI) => {
    try {
      const res = await CompanyServices.deleteCompanyApi(data);
      thunkAPI.dispatch(getCompanydetails(companyPagination));
      ResponseMessageHandler(res);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const updatepremiumfeaturesCompany = createAsyncThunk(
  "Company/updatepremiumfeaturesCompany",
  async ({ data, companyPagination }, thunkAPI) => {
    try {
      const res = await CompanyServices.createCompanyAPI(data);
      thunkAPI.dispatch(getCompanydetails(companyPagination));
      ResponseMessageHandler(res);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getCountryTimeZone = createAsyncThunk(
  "Company/getCountryTimeZone",
  async (data, thunkAPI) => {
    try {
      let res = await CompanyServices.getCountryTimeZoneAPI(data);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const applyLicencingtocountry = createAsyncThunk(
  "Company/applyLicencingtocountry",
  async ({ data, companyPagination }, thunkAPI) => {
    try {
      let res = await CompanyServices.applyLicencingtocountryAPI(data);
      thunkAPI.dispatch(getCompanydetails(companyPagination));
      thunkAPI.dispatch(
        getLicencingData({
          orderBy: "createdAt",

          sortBy: "DESC",
        })
      );

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getCompanyRelatedFields = createAsyncThunk(
  "Company/getCompanyRelatedFields",
  async (data, thunkAPI) => {
    try {
      let res = await CompanyServices.getCompanyRelatedFieldsAPI({
        ...data,

        isAllFieldVisible: true,
      });
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const setFieldCanbeUsedInHistorical = createAsyncThunk(
  "Company/setFieldCanbeUsedInHistorical",
  async ({ data, CompanyFieldListPagination }, thunkAPI) => {
    try {
      let res = await CompanyServices.setFieldCanbeUsedInHistoricalAPI(data);
      thunkAPI.dispatch(
        getCompanyRelatedFields({
          companyId: data.companyId,
          ...CompanyFieldListPagination,
        })
      );
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const DeleteDataField = createAsyncThunk(
  "Company/DeleteDataField",
  async ({ data, CompanyFieldListPagination }, thunkAPI) => {
    try {
      let res = await DatamanagerServices.DeleteDataFieldAPI(data);
      thunkAPI.dispatch(getCompanyRelatedFields(CompanyFieldListPagination));

      ResponseMessageHandler(res);

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const toggleSendgridUse = createAsyncThunk(
  "Company/toggleSendgridUse",
  async ({ data, companyPagination }, thunkAPI) => {
    try {
      const res = await CompanyServices.updateCompanyyAPI(data);
      thunkAPI.dispatch(getCompanydetails(companyPagination));
      ResponseMessageHandler(res);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getCreditsDetailByCompanyId = createAsyncThunk(
  "Company/getCreditsDetailByCompanyId",
  async (data, thunkAPI) => {
    try {
      const res = await CompanyServices.getCreditsDetailByCompanyIdAPI(data);

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const updateCreditsForCompany = createAsyncThunk(
  "Company/updateCreditsForCompany",
  async (data, thunkAPI) => {
    try {
      const res = await CompanyServices.updateCreditsForCompanyAPI(data);
      thunkAPI.dispatch(
        getCreditsDetailByCompanyId({
          companyId: data.companyId,
        })
      );
      ResponseMessageHandler(res);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const refillCreditsForCompany = createAsyncThunk(
  "Company/refillCreditsForCompany",
  async (data, thunkAPI) => {
    try {
      const res = await CompanyServices.refillCreditsForCompanyAPI(data);
      thunkAPI.dispatch(
        getCreditsDetailByCompanyId({
          companyId: data.companyId,
        })
      );
      ResponseMessageHandler(res);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
